<section class="step step-source">
    <header class="step-header">
        <h2>Where should we start?</h2>
        <p class="lede">Pick a starting point. You can always restructure later from the org board.</p>
    </header>

    <div class="cards">
        <button
            class="source-card"
            [class.selected]="isSelected('blank')"
            (click)="choose('blank')"
        >
            <mat-icon class="card-icon">grid_off</mat-icon>
            <span class="card-title">Blank</span>
            <span class="card-sub">Start from a completely empty board.</span>
        </button>

        <button
            class="source-card recommended"
            [class.selected]="isSelected('scaffold', 'minimal')"
            (click)="choose('scaffold', 'minimal')"
        >
            <span class="card-badge">Recommended</span>
            <mat-icon class="card-icon">account_tree</mat-icon>
            <span class="card-title">Rudimentary scaffold</span>
            <span class="card-sub">A CEO post, one Division, one Department — flesh out the rest.</span>
        </button>

        <button
            class="source-card"
            [class.selected]="isSelected('scaffold', 'with-executive-team')"
            (click)="choose('scaffold', 'with-executive-team')"
        >
            <mat-icon class="card-icon">supervisor_account</mat-icon>
            <span class="card-title">Scaffold + Exec team</span>
            <span class="card-sub">Same scaffold, plus an Executive Assistant post in the CEO's header.</span>
        </button>

        <button
            class="source-card"
            [class.selected]="isSelected('template')"
            [disabled]="isPickingSource"
            (click)="openTemplatePicker()"
        >
            <mat-icon class="card-icon">collections_bookmark</mat-icon>
            <span class="card-title">Curated template</span>
            <span class="card-sub">{{ isPickingSource ? 'Loading…' : 'Flash Components shape and other system templates.' }}</span>
        </button>

        <button
            class="source-card"
            [class.selected]="isSelected('clone')"
            [disabled]="isPickingSource"
            (click)="openClonePicker()"
        >
            <mat-icon class="card-icon">content_copy</mat-icon>
            <span class="card-title">Clone an org I admin</span>
            <span class="card-sub">{{ isPickingSource ? 'Loading…' : 'Start from the shape of an existing organization.' }}</span>
        </button>

        <button
            class="source-card"
            [class.selected]="isSelected('excel')"
            [disabled]="isImporting"
            (click)="openExcelPicker()"
        >
            <mat-icon class="card-icon">upload_file</mat-icon>
            <span class="card-title">Import from Excel</span>
            <span class="card-sub">{{ isImporting ? 'Importing…' : 'Drop in a workbook with structure + staff.' }}</span>
        </button>
    </div>

    <input
        #excelInput
        type="file"
        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        hidden
        (change)="onExcelFileChosen($event)"
    />
</section>
